// extracted by mini-css-extract-plugin
module.exports = {"BlockQuote":"styles_BlockQuote__2pNP4","bg_1":"styles_bg_1__ph8TE","bg_2":"styles_bg_2__MZFP5","bg_sm":"styles_bg_sm__49aMZ","height":"styles_height__MqgHX"};